/**
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 */
/** Possible score values for recommended servers. */
var RecommendedServerInfoScore;
(function (RecommendedServerInfoScore) {
    RecommendedServerInfoScore[RecommendedServerInfoScore["GREAT"] = 2] = "GREAT";
    RecommendedServerInfoScore[RecommendedServerInfoScore["GOOD"] = 1] = "GOOD";
    RecommendedServerInfoScore[RecommendedServerInfoScore["OK"] = 0] = "OK";
    RecommendedServerInfoScore[RecommendedServerInfoScore["BAD"] = -1] = "BAD";
})(RecommendedServerInfoScore || (RecommendedServerInfoScore = {}));

export { RecommendedServerInfoScore };
